import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  EasyLoadingHead: {
    VocTyp: "",
    // VocTypName: "",
    VocNo: 0,
    PostDate: new Date(),
    Party: "",
    PartyName: "",
    Status: "A",
    dropid: "",
    CBM: "",
    RefNo: "",
  },
  EasyLoadingSubHeader: {
    vocType:'',
    TruckId: "",
    DriverID: "",
    TruckName: "",
    DriverName: "",
    LoadedCBM: 0,
    TruckCBM: 0,
    DocStatus: "ENTER",
    CurrentTripID:""
  },
  EasyLoadingList: [
    {
      DocTypCode: "",
      DocTypName: "",
      Date: "",
      Status: "",
    },
  ],
  EasyLoadingData: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    statusVal: "",
    Scan: "",
  },
};

const SliceEasyLoading = createSlice({
  name: "EasyLoading",
  initialState: { value: initialState },

  reducers: {
    EasyLoadingHead_Set: (state, action) => {
      state.value.EasyLoadingHead = action.payload;
    },
    EasyLoadingSubHeader_Set: (state, action) => {
      state.value.EasyLoadingSubHeader = action.payload;
    },
    EasyLoadingSubHeader_VocType_Set: (state, action) => {
      state.value.EasyLoadingSubHeader.vocType = action.payload.vocType;
      
    },
    EasyLoadingSubHeader_Truck_Set: (state, action) => {      
      state.value.EasyLoadingSubHeader.TruckId = action.payload.TruckId;
      state.value.EasyLoadingSubHeader.TruckName = action.payload.TruckName;
      state.value.EasyLoadingSubHeader.DriverID = action.payload.DriverID;
      state.value.EasyLoadingSubHeader.DriverName = action.payload.DriverName;
      state.value.EasyLoadingSubHeader.TruckCBM = action.payload.TruckCBM;
    },
    EasyLoadingHead_Status_Set: (state, action) => {
      state.value.EasyLoadingHead.Status = action.payload.Status;
    },
    EasyLoadingList_Set: (state, action) => {
      state.value.EasyLoadingList = action.payload;
    },
    EasyLoadingData_Set: (state, action) => {
      state.value.EasyLoadingData = action.payload;
    },
    EasyLoadingData_OnLoad_Set: (state, action) => {
      state.value.EasyLoadingData = action.payload;
    },
    EasyLoading_Init: (state) => {
      state.value = initialState;
    },
    EasyLoading_Head_Init: (state) => {
      state.value.EasyLoadingHead = initialState.EasyLoadingHead;
      state.value.EasyLoadingSubHeader = initialState.EasyLoadingSubHeader;
    },
  },
});

export const {
  EasyLoadingHead_Set,
  EasyLoading_Head_Init,
  EasyLoadingSubHeader_Set,
  EasyLoadingSubHeader_VocType_Set,
  EasyLoadingSubHeader_Truck_Set,
  EasyLoading_Init,
  EasyLoadingList_Set,
  EasyLoadingData_Set,
  EasyLoadingHead_Status_Set,
  EasyLoadingData_OnLoad_Set,
} = SliceEasyLoading.actions;
export default SliceEasyLoading.reducer;
